import React from "react";
import * as MUI from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTranslation } from "react-i18next";
import { MATERIAL } from "./ReferralType";
import DetailRow from "../../../../components/display/DetailRow";

function DialogHeader({ template, canEdit, canDelete, onClose, onEdit, onDelete }) {
  const { t } = useTranslation();

  return (
    <MUI.DialogTitle sx={{ p: { xs: 2.5, sm: 3.5 }, pt: { xs: 1, sm: 1.25 } }}>
      <MUI.Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2 }}
      >
        <MUI.Stack direction="row" spacing={0.5}>
          {canDelete && (
            <MUI.Tooltip title={t("Delete")}>
              <MUI.IconButton
                onClick={() => onDelete(template)}
                size="small"
                color="error"
              >
                <DeleteIcon fontSize="small" />
              </MUI.IconButton>
            </MUI.Tooltip>
          )}
          {canEdit && (
            <MUI.Tooltip title={t("Edit")}>
              <MUI.IconButton onClick={() => onEdit(template)} size="small">
                <EditIcon fontSize="small" />
              </MUI.IconButton>
            </MUI.Tooltip>
          )}
        </MUI.Stack>

        <MUI.IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </MUI.IconButton>
      </MUI.Stack>

      <MUI.Stack direction="row" spacing={2} alignItems="center">
        <MUI.Avatar
          variant="rounded"
          sx={{
            bgcolor: "primary.main",
            width: 52,
            height: 52,
            borderRadius: 2.5,
          }}
        >
          <AssignmentIcon />
        </MUI.Avatar>
        <MUI.Box sx={{ minWidth: 0 }}>
          <MUI.Typography
            variant="h6"
            sx={{ fontWeight: 700, lineHeight: 1.25 }}
            noWrap
          >
            {template?.title}
          </MUI.Typography>
          <MUI.Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
            <MUI.Chip
              label={t(template?.referralType)}
              size="small"
              color="primary"
            />
          </MUI.Stack>
        </MUI.Box>
      </MUI.Stack>
    </MUI.DialogTitle>
  );
}

function DialogBody({ template }) {
  const { t } = useTranslation();

  return (
    <MUI.DialogContent
      dividers
      sx={{
        p: { xs: 2.5, sm: 3.5 },
        bgcolor: (theme) =>
          theme.palette.mode === "light"
            ? "grey.50"
            : "rgba(255,255,255,0.02)",
      }}
    >
      <MUI.Stack spacing={2.5}>
        <DetailRow label={t("Institution")} value={template?.institution?.name} />
        <DetailRow label={t("Diagnosis")} value={template?.diagnosis} />
        <DetailRow label={t("RequestedExam")} value={template?.requestedExam} />
        {template?.referralType === MATERIAL && (
          <>
            <DetailRow label={t("Material")} value={template?.material} />
            <DetailRow label={t("NumberOfSamples")} value={template?.numberOfSamples} />
          </>
        )}
      </MUI.Stack>
    </MUI.DialogContent>
  );
}

export default function ReferralTemplateDetailsDialog({
  template,
  canEdit,
  canDelete,
  onClose,
  onEdit,
  onDelete,
}) {
  const theme = MUI.useTheme();
  const fullScreen = MUI.useMediaQuery(theme.breakpoints.down("md"));

  return (
    <MUI.Dialog
      open={Boolean(template)}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 4 } }}
    >
      <DialogHeader
        template={template}
        canEdit={canEdit}
        canDelete={canDelete}
        onClose={onClose}
        onEdit={onEdit}
        onDelete={onDelete}
      />
      <DialogBody template={template} />
    </MUI.Dialog>
  );
}
